import React, { useState } from 'react';
import { Paper, Button, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AddTask from './AddTask';
import { TaskStatus, TaskPriority } from '../../../../utils/enums';
import useApiManager from '../../../../utils/Api/apiManager';
import ConfirmationDialog from '../../../ConfirmationDialog/ConfirmationDialog';

const MarkCompleted = ({ hover }) => (
    <Box sx={{ position: 'relative', width: '20px', height: '22px' }}>
        {hover && <CheckCircleOutlineIcon />}
    </Box>
);

const OpenActivities = ({ data, fetchLeadTasks, fetchClosedTasks }) => {
    const { put } = useApiManager();
    const [isModalOpen, setModalOpen] = useState(false);
    const [hoveredRow, setHoveredRow] = useState(null);
    // const [openDialog, setOpenDialog] = useState(false);
    // const [currentRow, setCurrentRow] = useState('');

    // const handleOpenDialog = () => {
    //     setOpenDialog(true);
    // };

    // const handleCloseDialog = () => {
    //     setOpenDialog(false);
    // };

    // const handleConfirmAction = () => {
    //     handleMarkConfirmed();
    //     handleCloseDialog();
    // };

    const handleMarkConfirmed = async (taskId) => {
        try {
            const confirmed = await put(`/tasks/${taskId}/complete`);
            fetchLeadTasks();
            fetchClosedTasks();
        } catch (error) {
            console.error('Error marking task as completed:', error);
        }
    };

    return (
        <Paper elevation={0} sx={{ p: 1 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px' }}>
                <h4>Open Activities</h4>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Button variant="contained" type="submit" onClick={() => setModalOpen(true)}>Add New</Button>
                    <AddTask open={isModalOpen} onClose={() => setModalOpen(false)} fetchLeadTasks={fetchLeadTasks} />
                </Box>
            </Box>

            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell width={10}>-</TableCell> {/* Fixed width */}
                            <TableCell sx={{ maxWidth: 250 }}>Subject</TableCell>                 {/* Auto width / stretch */}
                            <TableCell>Due Date</TableCell>
                            <TableCell>Task Owner</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Priority</TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {data?.map((row) => (
                            <TableRow
                                key={row.id}
                                onMouseEnter={() => setHoveredRow(row.id)}
                                onMouseLeave={() => setHoveredRow(null)}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <Tooltip title="Mark as completed">
                                    <TableCell sx={{ width: '20px', height: '22px', padding: '8px', cursor: 'pointer' }}
                                        onClick={() => {
                                            // setCurrentRow(row);
                                            handleMarkConfirmed(row.id); // Pass ID directly
                                        }
                                        }>
                                        <MarkCompleted hover={hoveredRow === row.id} />

                                    </TableCell>
                                </Tooltip>
                                <TableCell component="th" scope="row" sx={{
                                    maxWidth: 250,
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal', // allow wrapping
                                }}>
                                    <Link to={`/tasks/${row.id}`}>{row.subject || 'No subject'}</Link>
                                </TableCell>
                                <TableCell>{row.dueDate ? format(new Date(row.dueDate), 'MMMM do yyyy') : 'No due date'}</TableCell>
                                <TableCell>{row.ownerName || 'No owner name'}</TableCell>
                                <TableCell>{TaskStatus?.[row.status]?.label || 'Unknown Status'}</TableCell>
                                <TableCell>{TaskPriority?.[row.priority]?.label || 'Unknown Priority'}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {/* <ConfirmationDialog
                open={openDialog}
                title="Confirm Action"
                content="Are you sure you want to mark this task as completed?"
                onClose={handleCloseDialog}
                onConfirm={handleConfirmAction}
                confirmText="Confirm"
                cancelText="Cancel"
            /> */}
        </Paper>
    );
};

export default OpenActivities;
